/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterSearchSelectorPipe' })
export class FilterSearchSelectorPipe implements PipeTransform {
  transform(columns: any, args: string) {
    if (columns) {
      columns.forEach((columnGroup: any) => {
        columnGroup.show = false;
        if (columnGroup.groupFilters.default) {
          columnGroup.groupFilters.default.forEach((filter: any) => {
            if (filter.name.toLowerCase().match(args.toLowerCase()) || args === '') {
              columnGroup.show = true;
              filter.show = true;
            } else {
              filter.show = false;
            }
          });
        } else {
          const keys = Object.keys(columnGroup.groupFilters);
          keys.forEach((key) => {
            const filters = columnGroup.groupFilters[key];
            filters.show = false;
            filters.forEach((filter: any) => {
              if (filter.name.toLowerCase().match(args.toLowerCase()) || args === '') {
                columnGroup.show = true;
                filters.show = true;
                filter.show = true;
              } else {
                filter.show = false;
              }
            });
          });
        }

        columnGroup.filters.forEach((filter: any) => {
          if (filter.name.toLowerCase().match(args.toLowerCase()) || args === '') {
            columnGroup.show = true;
            filter.show = true;
          } else {
            filter.show = false;
          }
        });
      });
      return columns;
    } else {
      return [];
    }
  }
}

@Pipe({ name: 'filterSearchSelectorShowPipe' })
export class FilterSearchSelectorShowPipe implements PipeTransform {
  transform(columns: any, format?: string) {
    if (columns) {
      return columns.filter((item: any) => item.show || item.show == undefined);
    }
  }
}
